<script>
  import { foodJournalLink } from '../config';
</script>

<style>
  .km-title {
    font-family: 'axiformaheavy';
    font-weight: 700;
    font-size: 24px;
    line-height: 1.5;
    margin-bottom: 8px;
  }

  .km-subline {
    font-size: 14px;
    line-height: 1.7;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .km-subline a {
    text-decoration: underline;
    color: #3a3a3a;
  }

  .km-subline a:hover {
    color: #555;
  }

  .km-subline a:visited {
    color: #7f7f7f;
  }

  @media (min-width: 800px) {
    .km-headline {
      width: 250px;
    }

    .km-title {
      font-size: 28px;
    }
  }
</style>

<div class="km-headline" id="koromap__headline">
  <div class="km-title" id="koromap__title">Woher kommen unsere Produkte?</div>
  <div class="km-subline" id="koromap__subtitle">
    Transparenz ist Kern unserer Philosophie bei KoRo. Wir wollen Dir zeigen, woher unsere Produkte kommen und welche Mengen dahinter stecken.
    {#if document.getElementsByClassName("blog--detail").length === 0}
      <span>Mehr dazu im <a href={foodJournalLink}>Food Journal.</a></span>
    {/if}
  </div>
</div>
